import { readUtm } from "@/components/WhatsAppButton";
import { fbTrackingPayload } from "@/lib/fbTracking";

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";

/** Unique 6-char code, e.g. r7K2QX. */
export function genLeadCode(): string {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join("");
}

function channelOf(url: URL): "whatsapp" | "telegram" | null {
  const h = url.hostname.replace(/^www\./, "");
  if (h === "wa.me" || h === "api.whatsapp.com") return "whatsapp";
  if (h === "t.me" || h === "telegram.me") return "telegram";
  return null;
}

function sendClick(channel: string, code: string, href: string) {
  const utm = readUtm();
  const qs = new URLSearchParams(window.location.search);
  fbTrackingPayload()
    .catch(() => ({ tracking_allowed: false }))
    .then((fb) => {
      if (fb.tracking_allowed) {
        try {
          (window as any).fbq?.("track", "Contact");
        } catch {
          /* ignore */
        }
      }
      const endpoint = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/submit-lead`;
      fetch(endpoint, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
        },
        body: JSON.stringify({
          page: "messenger_click",
          channel,
          lead_code: code,
          link: href,
          page_url: window.location.href.slice(0, 500),
          utm_source: utm.utm_source || qs.get("utm_source") || "",
          utm_medium: qs.get("utm_medium") || "",
          utm_campaign: qs.get("utm_campaign") || "",
          utm_content: qs.get("utm_content") || "",
          utm_term: qs.get("utm_term") || "",
          gclid: utm.gclid || "",
          ...fb,
        }),
      }).catch(() => {});
    });
}

/** Adds a unique #CODE to every WhatsApp / Telegram link on click and reports the click. */
export function installMessengerClickTracking() {
  if (typeof document === "undefined") return;
  document.addEventListener(
    "click",
    (e) => {
      const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!a) return;
      let url: URL;
      try {
        url = new URL(a.href);
      } catch {
        return;
      }
      const channel = channelOf(url);
      if (!channel) return;
      const code = genLeadCode();
      if (channel === "whatsapp") {
        const base = (url.searchParams.get("text") || "Hi! I'm a lead from Facebook")
          .replace(/\s*#[A-Za-z0-9]{6}$/, "")
          .replace(/\s*\p{Extended_Pictographic}+\s*$/u, "");
        url.searchParams.set("text", `${base} #${code}`);
      } else {
        const prev = (url.searchParams.get("start") || "site").replace(/_[A-Za-z0-9]{6}$/, "");
        url.searchParams.set("start", `${prev.slice(0, 50)}_${code}`);
      }
      a.href = url.toString();
      sendClick(channel, code, a.href);
    },
    true,
  );
}
